import {
  IonBackButton,
  IonButtons,
  IonHeader,
  IonItem,
  IonLabel,
  IonList,
  IonPage,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { useTranslation } from "react-i18next";
import { Content } from "@/components/content";

export function PrivacyPage() {
  const { t } = useTranslation();

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton />
          </IonButtons>
          <IonTitle>{t("routes:privacy.title")}</IonTitle>
        </IonToolbar>
      </IonHeader>

      <Content className="part-scroll:gap-6">
        <div className="space-y-6 px-4 py-6">
          <div className="space-y-4">
            <h2 className="text-xl font-semibold text-txt-primary">Productanalyse</h2>

            <div className="space-y-3 text-txt-secondary">
              <p>
                Wij verzamelen anonieme gebruiksgegevens om te begrijpen hoe ons platform wordt
                gebruikt en om de bruikbaarheid en prestaties te verbeteren. Deze gegevens worden
                verzameld op basis van gerechtvaardigd belang.
              </p>

              <div>
                <h3 className="mb-2 font-medium text-txt-primary">
                  Welke gegevens verzamelen wij:
                </h3>
                <ul className="ml-4 list-disc space-y-1">
                  <li>Anonieme gebruiksstatistieken en interacties binnen de app</li>
                  <li>Technische informatie zoals apparaattype en browserversie</li>
                  <li>Functionaliteitsgebruik en navigatiepatronen</li>
                </ul>
              </div>

              <div>
                <h3 className="mb-2 font-medium text-txt-primary">Doel van de verwerking:</h3>
                <ul className="ml-4 list-disc space-y-1">
                  <li>Verbetering van de gebruikerservaring</li>
                  <li>Optimalisatie van app-prestaties</li>
                  <li>Identificatie en oplossing van technische problemen</li>
                </ul>
              </div>

              <div>
                <p>
                  <strong className="text-txt-primary">Rechtsgrond:</strong> Gerechtvaardigd belang
                  (artikel 6, lid 1, onder f) van de AVG)
                </p>
              </div>

              <div className="space-y-2 rounded-lg bg-gray-50 p-4">
                <h3 className="font-medium text-txt-primary">Belangrijke punten:</h3>
                <ul className="ml-4 list-disc space-y-1 text-sm">
                  <li>Wij gebruiken deze gegevens nooit voor marketing doeleinden</li>
                  <li>Wij verkopen uw gegevens nooit aan derden</li>
                  <li>Alle gegevens worden anoniem verwerkt</li>
                </ul>
              </div>

              <div className="rounded-lg bg-gray-50 p-4">
                <h3 className="mb-2 font-medium text-txt-brand">Uw rechten:</h3>
                <p className="text-sm text-txt-brand">
                  U kunt zich op elk moment afmelden voor deze gegevensverzameling of verzoeken om
                  verwijdering van uw gegevens door contact op te nemen met{" "}
                  <a
                    href="mailto:privacy@heyboomer.nl"
                    className="font-medium text-txt-brand underline"
                  >
                    privacy@heyboomer.nl
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </Content>
    </IonPage>
  );
}
